import script from "./Popup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popup.vue?vue&type=script&setup=true&lang=ts"

import "./Popup.vue?vue&type=style&index=0&id=3b4d0c2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b4d0c2c"]])

export default __exports__